import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "about" }
const _hoisted_2 = { class: "topback22" }
const _hoisted_3 = {
  key: 0,
  class: "swperList"
}
const _hoisted_4 = { class: "radioBox" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "ip" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_question = _resolveComponent("question")!
  const _component_jieGuo = _resolveComponent("jieGuo")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", null, _toDisplayString($data.questions[$props.postaimqus].bigTitle), 1)
      ]),
      ($props.postaimqus == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_van_image, {
              width: "5.2667rem",
              height: "4.8rem",
              src: require('../assets/gongge.jpg')
            }, null, 8, ["src"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_van_checkbox_group, {
        modelValue: $data.checkVal,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.checkVal) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questions[$props.postaimqus].radioList, (items, index) => {
              return (_openBlock(), _createBlock(_component_van_checkbox, {
                modelValue: $setup.checkedd,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.checkedd) = $event)),
                key: index,
                value: items.name,
                name: items.name
              }, {
                icon: _withCtx((props) => [
                  _createElementVNode("img", {
                    class: "img-icon",
                    src: props.checked ? $setup.activeIcon : $setup.inactiveIcon
                  }, null, 8, _hoisted_5)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(items.title) + " ", 1)
                ]),
                _: 2
              }, 1032, ["modelValue", "value", "name"]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_van_popup, {
      show: $data.show,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (($data.show) = $event))
    }, {
      default: _withCtx(() => [
        ($data.flag == 'question')
          ? (_openBlock(), _createBlock(_component_question, {
              key: 0,
              onOnChanged: $options.updateChanged,
              postaimqus: $props.postaimqus
            }, null, 8, ["onOnChanged", "postaimqus"]))
          : _createCommentVNode("", true),
        ($data.flag == 'jieGuo')
          ? (_openBlock(), _createBlock(_component_jieGuo, {
              key: 1,
              onOnChanged: $options.updateChanged,
              postaimqus: $props.postaimqus
            }, null, 8, ["onOnChanged", "postaimqus"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_van_image, {
        class: "footBtn",
        onClick: $options.jieguo,
        width: "3.9333rem",
        height: "1.1467rem",
        src: require('../assets/jiemi.png')
      }, null, 8, ["onClick", "src"])
    ]),
    _hoisted_7
  ], 64))
}